// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"254":"a38c4802","724":"9fa6dfc3"}[chunkId] + ".css";
};